import { render, staticRenderFns } from "./XinzengTidan.vue?vue&type=template&id=12f2ca97&"
import script from "./XinzengTidan.vue?vue&type=script&lang=js&"
export * from "./XinzengTidan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports